import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages.routing';
import { PagesComponent } from './pages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { LandingPageComponent } from './landing-page/landing-page.component';
@NgModule({
  imports: [
    CommonModule,
    PagesRoutingModule
],
  declarations: [PagesComponent, ]
})
export class PagesModule {
}
